import React, { FC } from 'react'
import { getProps } from './utils'

import {
  FormFieldProps,
} from '../../../../types/frontend/form'

const HTML: FC<React.PropsWithChildren<FormFieldProps>> = (props) => {
  const {
    item,
  } = getProps(props)

  return (
    <div dangerouslySetInnerHTML={{ __html: item.helperText || '' }}>
    </div>
  )
}

export default HTML